import axios from "axios";
import {useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";

import "./safetyForm.css"

export default function SF() {
    const [data, setData] = useState();

    useEffect(() => {
        axios.get("https://api-als2.nutramax.com/items/safety_forms")
        .then( response => {
            setData(response.data.data);
        })
    }, [])
    return (
        <div id="safetyForm">
            <h4> Safety Forms </h4>
            <div className="links-div">

            {data? data.map(({ name, file, id}) =>  { return (
                <div key={id}>
                    <FontAwesomeIcon icon={faFile} color="whitesmoke"/>
                <a  href={`https://api-als2.nutramax.com/assets/${file}?download`} download={name} alt={name}> {name} </a>
                </div>
            )
            }): null}
            
            </div>
        </div>
    )
}